import {ExpandMore} from '@mui/icons-material';
import {Accordion, AccordionDetails, AccordionSummary, Divider, Stack} from '@mui/material';
import {SessionQuestion} from '@cp/model';
import ImageDisplayFromStorage from '../../atoms/imageDisplayFromStorage/ImageDisplayFromStorage';
import QuestionReviewQuestionExplanation from './QuestionReviewQuestionExplaination';
import QuestionReviewQuestionOptions from './QuestionReviewQuestionOptions';
import QuestionReviewQuestionSummary from './QuestionReviewQuestionSummary';
import QuestionReviewQuestionSummaryTopic from './QuestionReviewQuestionSummaryTopic';

export interface QuestionReviewQuestionProps {
  question: SessionQuestion;
  index: number;
}

export default function QuestionReviewQuestion({question, index}: QuestionReviewQuestionProps) {
  return (
    <Accordion
      data-testid={`review-question-${index + 1}`}
      sx={{
        p: 1,
        border: '1px solid',
        borderColor: 'divider',
        '&:before': {
          display: 'none', // Remove default accordion border
        },
      }}
    >
      <AccordionSummary
        data-testid={`review-question-${index + 1}-summary`}
        expandIcon={<ExpandMore />}
        sx={{
          px: {xs: 1, sm: 2},
          py: {xs: 1, sm: 1.5},
          '&.Mui-expanded': {
            minHeight: 'auto',
          },
          '& .MuiAccordionSummary-content': {
            margin: 0,
            '&.Mui-expanded': {
              margin: 0,
            },
          },
        }}
      >
        <QuestionReviewQuestionSummary question={question} index={index} />
      </AccordionSummary>
      <AccordionDetails
        data-testid={`review-question-${index + 1}-details`}
        sx={{px: {xs: 1, sm: 2}, py: {xs: 1, sm: 2}}}
      >
        <Stack spacing={{xs: 1.5, sm: 2}}>
          <ImageDisplayFromStorage imageUrl={question.imageUrl} />
          <QuestionReviewQuestionOptions question={question} />
          <Divider />
          <QuestionReviewQuestionExplanation question={question} />
          <Divider />

          {/* Topic details accordion */}
          <QuestionReviewQuestionSummaryTopic question={question} />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
